import { ProductPage } from "./ProductPage";
import { buildTv5UltraConfig } from "./configs/tv5-ultra";

export function Tv5UltraPage() {
  return <ProductPage build={buildTv5UltraConfig} />;
}
